import {
  SET_ACHIEVEMENT_LIST,
  SET_ACHIEVEMENT_LIST_LOADING,
  SET_ACHIEVEMENT_AMOUNT,
} from './mutation-type'
import api from '@/api'
import { checkUserName } from '@/views/User/utils'

const state = {
  achievementList: {
    pageNum: 1,
    pageCount: 0,
    total: 0,
    size: 50,
    items: [],
  },
  achievementAmount: {
    netReceiptsRmb: 0,
    receivableRmb: 0,
    arrearsRmb: 0,
    refundRmb: 0,
    netReceiptsUsd: 0,
    receivableUsd: 0,
    arrearsUsd: 0,
    refundUsd: 0,
  },
  loadingDatas: false,
}
const mutations = {
  [SET_ACHIEVEMENT_LIST](state, payload) {
    state.achievementList = payload
  },
  [SET_ACHIEVEMENT_AMOUNT](state, payload) {
    state.achievementAmount = payload
  },
  [SET_ACHIEVEMENT_LIST_LOADING](state, payload) {
    state.loadingDatas = payload
  },
}
const actions = {
  async getAchievementList({ commit, dispatch }, payload) {
    commit(SET_ACHIEVEMENT_LIST_LOADING, true)
    try {
      const [{ data: listData, code: listCode }, { data: amountData }] = await Promise.all([
        api.statisticsApi.queryAchievement(payload),
        api.statisticsApi.achievementAmountStatistics(payload),
      ])
      checkUserName({
        code: listCode,
        data: listData,
        callback: ({userId}) => {
          const { userName, ...other } = payload
          dispatch('getAchievementList', {
            ...other,
            userId,
          })
        },
      })
      commit(SET_ACHIEVEMENT_LIST, listData)
      commit(SET_ACHIEVEMENT_AMOUNT, amountData)
    } catch (e) {
      console.error(e)
    }
    commit(SET_ACHIEVEMENT_LIST_LOADING, false)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
